import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { TextField, Box } from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import If from '../condicional/if';

export default function DataTableComponent({ columns, data, visibleSearch, camposParaBusca = ['nome'] }) {

    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState([]);

    useEffect(() => {
        const searchTerm = search.toLowerCase();
    
        const result = data.filter(item => {
            return camposParaBusca.some(campo =>
                item[campo] && item[campo].toString().toLowerCase().includes(searchTerm)
            );
        });

        setFilter(result);
    }, [search, data]);

    useEffect(() => {
        setFilter(data);
    }, [data]);

    const tableHeaderStyle = {
        headCells: {
            style: {
                fontWeight: 'bold',
                fontSize: '14px',
                backgroundColor: '#e8e8e8'
            }
        }
    }

    const paginationComponentOptions = {
        rowsPerPageText: 'Itens por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <DataTable
            noDataComponent={
                <h3 style={{ textAlign: 'center', padding: '40px' }}>Nenhum registro encontrado.</h3>
            }
            customStyles={tableHeaderStyle}
            columns={columns}
            data={filter}
            pagination
            paginationComponentOptions={paginationComponentOptions}
            fixedHeader
            selectableRows={false}
            selectableRowsHighlight
            highlightOnHover
            subHeader={visibleSearch}
            subHeaderComponent={
                <If test={visibleSearch}>
                    <TextField
                        label="Campo de pesquisa"
                        type="search"
                        variant="outlined"
                        size="small"
                        color='secondary'
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position='end'>
                                    <IconButton>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                </If>
            }
        />
    )
}